<template>
	<v-flex>
		<v-card align-start flat>
			<v-card-text>
				<v-form ref="braintree_form" v-model="new_cc.valid" lazy-validation>
					<v-layout wrap justify-space-between>
						<v-flex xs12 md12>
							<v-layout d-flex wrap>
								<v-flex py-0 md5>
									<styled-text-field
											name="number"
											watch-id="cc-number"
											focused-classes="braintree-hosted-fields-focused"
											filled-classes="braintree-hosted-fields-valid braintree-hosted-fields-invalid"
											label="CC Number"
											class="co-text-field"
											:has-error="error_number"
											:errorText="error_number ? 'Invalid value' : ''"
									>
										<div id="cc-number" class="cc-field"></div>
									</styled-text-field>
								</v-flex>
								<v-flex py-0 md7 class="cc_icons">
									<v-img src="/checkout/assets/cc_visa.png" contain position="top left" v-bind="ADAattr('hidden')"></v-img>
									<v-img src="/checkout/assets/cc_mc.png" contain position="top left" v-bind="ADAattr('hidden')"></v-img>
									<v-img src="/checkout/assets/cc_amex.png" contain position="top left" v-bind="ADAattr('hidden')"></v-img>
									<v-img src="/checkout/assets/cc_discover.png" contain position="top left" v-bind="ADAattr('hidden')"></v-img>
								</v-flex>
							</v-layout>
							<v-layout d-flex wrap>
								<v-flex py-0 md5>
									<styled-text-field
											name="expirationDate"
											watch-id="cc-exp-date"
											focused-classes="braintree-hosted-fields-focused"
											filled-classes="braintree-hosted-fields-valid braintree-hosted-fields-invalid"
											label="Expiration Date"
											class="co-text-field"
											:has-error="error_exp_date"
											:errorText="error_exp_date ? 'Invalid value' : ''"
									>
										<div id="cc-exp-date" class="cc-field"></div>
									</styled-text-field>

								</v-flex>
							</v-layout>
							<v-layout d-flex wrap>
								<v-flex py-0 md5>
									<styled-text-field
											name="cvv"
											watch-id="cc-cvv"
											focused-classes="braintree-hosted-fields-focused"
											filled-classes="braintree-hosted-fields-valid braintree-hosted-fields-invalid"
											label="CVV"
											class="co-text-field"
											:has-error="error_cvv"
											:errorText="error_cvv ? 'Invalid value' : ''"
									>
										<div id="cc-cvv" class="cc-field"></div>
									</styled-text-field>
								</v-flex>
							</v-layout>
							<v-layout d-flex wrap>
								<v-flex py-0 md5>
									<v-text-field
											v-model="new_cc.cardholder"
											label="Cardholder Name"
											required
											:rules="rules.cardholder_name"
											id="cc-holder-name"
											name="cc-holder-name"
											class="co-text-field"
									></v-text-field>

								</v-flex>

							</v-layout>
						</v-flex>

						<v-flex xs12>
							<v-layout wrap justify-space-between>
								<v-flex xs12>
									<v-checkbox
											v-model="same_address"
											v-if="enableSameAddressAsShipping"
											label="Billing address same as shipping"
											hide-details
											class="my-0"
									></v-checkbox>

									<add-edit-shipping-address-form
											v-if="!same_address"
											ref="billing_address"
											id="ada-braintree-address"
									></add-edit-shipping-address-form>

									<v-checkbox label="Save credit card" v-model="save_cc" :disabled="save_card_required" hide-details class="my-0"></v-checkbox>

								</v-flex>

								<v-flex xs12 md5 py-0 v-if="save_cc">
									<v-text-field
											v-model="new_cc.label"
											label="Credit Card Label"
											required
											:rules="rules.label"
											id="cc-label"
											name="cc-label"
											class="co-text-field"
									></v-text-field>
								</v-flex>

							</v-layout>
						</v-flex>
					</v-layout>
				</v-form>

			</v-card-text>
		</v-card>
	</v-flex>
</template>

<script>
	import braintree from 'braintree-web';
	import _ from 'lodash';
	import StyledTextField from './StyledTextField';
	import AddEditShippingAddressForm from './AddEditShippingAddressForm';

	export default {
		name: "BraintreeCCForm",

		components: {
			StyledTextField,
			AddEditShippingAddressForm,
		},

		props: {
			enableSameAddressAsShipping: {
				type: Boolean,
				default: true,
			},
			braintree_token: {
				type: String,
				default: '',
			},
			save_card_required: {
				type: Boolean,
				default: false,
			},
			invalidFields: {
				type: Array,
				default: [],
			},
		},

		data() {
			const self = this;

			return {
				new_cc: {
					valid: true,
					cardholder: '',
					label: '',
				},

				braintree_hosted_field_instance: null,
				braintree_device_data: null,

				same_address: false,
				save_cc: false,

				rules: {
					cardholder_name: [
						v => (typeof v === "string" && !!v.trim()) || 'Cardholder Name is required',
						v => (v = /[!<>"%]+/.exec(v)) === null || 'Invalid format.' + (v[0] && v[0][0] ? ` "${v[0][0]}" character is not allowed` : ''),
					],
					label: [
						v => !self.save_cc || (typeof v === "string" && !!v.trim()) || 'Label is required',
						v => (v = /[!<>"%]+/.exec(v)) === null || 'Invalid format.' + (v[0] && v[0][0] ? ` "${v[0][0]}" character is not allowed` : ''),
					],
				},
			};
		},

		mounted() {
			const self = this;
			if (self.save_card_required) {
				self.save_cc = true;
			}
			braintree.client.create({
				authorization: self.braintree_token,
			})
				.then(instance => {
					let options = {
						client: instance,
						styles: {
							input: {
								'font-size': '16px',
								'font-family': 'Roboto,sans-serif',
								'padding': '8px 10px',
							},
						},
						fields: {
							number: {
								selector: '#cc-number',
								placeholder: '',
								prefill: '',
							},
							cvv: {
								selector: '#cc-cvv',
								placeholder: '',
								prefill: '',
							},
							expirationDate: {
								selector: '#cc-exp-date',
								placeholder: '',
								prefill: '',
							},
						},
					};

					return braintree.hostedFields.create(options).then((hosted_fields) => {
						self.braintree_hosted_field_instance = hosted_fields;

						return braintree.dataCollector.create({
							client: instance,
							kount: true,
						}).then(function (data_collector_instance) {
							let device_data = data_collector_instance.deviceData;

							self.braintree_device_data = device_data;

							self.$emit('deviceDataReceived', device_data);
						});

					}).catch((error) => {
						console.error("BrainTree Error", error);
					});
				})
				.then(hosted_fields_instance => {
					// @TODO - Use hostedFieldInstance to send data to Braintree
				})
				.catch(err => {
				});
		},

		methods: {
			async submit() {
				const self = this;

				if (!self.$refs.braintree_form.validate()) {
					if (!self.same_address) {
						self.$refs.billing_address.fetch(); // to highlight invalid fields
					}

					this.$vuetify.goTo(self.$refs.braintree_form);
					return null;
				}

				let billing_address = null;
				if (!self.same_address) {
					billing_address = self.$refs.billing_address.fetch();
					if (billing_address === null) {
						return null;
					}
				}

				return new Promise(resolve => {
					self.braintree_hosted_field_instance.tokenize().then(payload => {
						resolve({
							success: true,
							data: {
								nonce: payload.nonce,
								card_type: payload.details.cardType,
								billing_address,
								save_cc: self.save_cc,
								cardholder_name: self.new_cc.cardholder,
								label: self.new_cc.label,
								device_data: self.braintree_device_data,
							},
						});

					}).catch(err => {
						console.error(err);

						resolve({
							success: false,
							data: err,
						});
					});
				});
			},
		},
		computed: {
			error_number() {
				return this.invalidFields.includes('number');
			},

			error_exp_date() {
				return this.invalidFields.includes('expirationDate');
			},

			error_cvv() {
				return this.invalidFields.includes('cvv');
			},
		}
	};
</script>

<style scoped lang="less">
	/deep/ .cc-field {
		max-height: 32px;
		width: 100%;

		iframe {
			height: 32px !important;
		}
	}

	.cc_icons {
		overflow: hidden;
		margin-left: 10px;

		.v-image {
			width: 32px;
			height: 20px;
			float: left;
			margin-top: 0;
			margin-bottom: 10px;
			margin-right: 10px;

			@media screen and (min-width: 600px) {
				margin-top: 22px;
				margin-bottom: 0;
			}
		}
	}
</style>